import axios from 'axios'

const path = 'certificates'

export default {
  async parseCertificate(pem) {
    const resp = await axios.post(`${path}/parse`, { pem })
    return resp.data
  }
}
